import Button from "astrid-components/lib/components/Inputs/Button";
import Modal from "astrid-components/lib/components/Modules/Modal";

import useText from "../../hooks/useText";

export default function ErrorModal({ text }) {
	const t = useText();

	return (
		<>
			<p style={{ textAlign: "center" }}>{text}</p>
			<div>
				<Button color="positive" onClick={() => Modal.setContent()}>
					{t("ok", "OK")}
				</Button>
			</div>
		</>
	);
}
